import { createFileRoute } from '@tanstack/react-router'
import { FollowupsScreen, REMINDER_TABS, type ReminderTab } from '../features/closeout'

/** `/followups?tab=answers|drafts|outcomes|next|settings` (#233, #276). The case trail links straight to a tab. */
export const Route = createFileRoute('/followups')({
  validateSearch: (raw: Record<string, unknown>): { tab?: ReminderTab } => ({
    tab: REMINDER_TABS.includes(raw.tab as ReminderTab) ? (raw.tab as ReminderTab) : undefined,
  }),
  component: function FollowupsRoute() {
    const { tab } = Route.useSearch()
    const navigate = Route.useNavigate()
    return (
      <FollowupsScreen
        tab={tab ?? 'drafts'}
        onTab={(next) => void navigate({ search: { tab: next === 'drafts' ? undefined : next }, replace: true })}
      />
    )
  },
})
